import React, { Component } from "react";
import { TextField, Button, Typography, Link } from "@material-ui/core";
import "../Login.css";
import { isNullOrEmpty } from "../Util";

export class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Email: "",
			Password: "",
		};
		this.setField = this.setField.bind(this);
		this.login = this.login.bind(this);
		this.sendPasswordReset = this.sendPasswordReset.bind(this);
	}
	setField = (name, value) => {
		var st = this.state;
		st[name] = value;
		this.setState(st);
	};

	async login() {
		var data = await fetch("User/CheckLogin", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				email: this.state.Email,
				password: this.state.Password,
			}),
		});
		var dt = data.ok ? await data.text() : false;

		if (!isNullOrEmpty(dt)) {
			document.location.href = "/dashboard";
			document.cookie = "role=" + dt;
		} else this.setState({ loginFailed: true });
	}

	async componentDidMount() { }

	sendPasswordReset() {
		if (isNullOrEmpty(this.state.Email)) {
			alert("Populate email address before attempting to reset password.");
			return;
		}

		fetch("User/SendPasswordReset", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(this.state.Email),
		}).then(x => {
			alert("If a matching user was found, a link to reset your password was sent to this email address.");
		});
	}

	render() {
		return (
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					textAlign: "center",
					height: "100%",
					backgroundImage: "url(img/login-background.jpg)",
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
				}}>
				<div className="login-wrapper">
					<div>
						<img src="../img/logo.png" alt="Dynamic Elevator Control" className="logo"></img>
					</div>
					<label className="login-label">Welcome! Please login.</label>
					<div className="login-control">
						<TextField
							variant="outlined"
							fullWidth={true}
							label="Email"
							onChange={(event) => {
								this.setField("Email", event.currentTarget.value);
							}}></TextField>
					</div>
					<div className="login-control">
						<TextField
							variant="outlined"
							fullWidth={true}
							label="Password"
							onChange={(event) => {
								this.setField("Password", event.currentTarget.value);
							}}
							onKeyPress={(event) => {
								if (event.which === 13) {
									this.login();
								}
							}}
							type="password"></TextField>
					</div>
					{this.state.loginFailed && (
						<Typography color="error" variant="h6">
							Invalid username or password.
						</Typography>
					)}
					<Button fullWidth={true} variant="contained" color="primary" className="login-button" onClick={this.login}>
						Login
					</Button>
					<Link onClick={this.sendPasswordReset}>Forgot Password?</Link>
				</div>
			</div>
		);
	}
}
